import React from "react";
import { useToast } from "../../hooks/use-toast";
import Icon from "../AppIcon";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast";

const variantIcons = {
  success: { name: "CheckCircle", color: "text-green-600", bg: "bg-green-100" },
  destructive: { name: "AlertCircle", color: "text-red-600", bg: "bg-red-100" },
  info: { name: "Info", color: "text-blue-600", bg: "bg-blue-100" },
  default: { name: "Bell", color: "text-slate-600", bg: "bg-slate-100" },
};

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, variant = "default", ...props }) => {
        const iconConfig = variantIcons[variant] || variantIcons.default;
        
        return (
          <Toast key={id} variant={variant} {...props} className="bg-white border-slate-200 shadow-xl">
            <div className="flex items-center gap-4 w-full">
              <div className={`shrink-0 flex items-center justify-center w-10 h-10 rounded-full ${iconConfig.bg} ${iconConfig.color}`}>
                <Icon name={iconConfig.name} size={22} strokeWidth={2.5} />
              </div>
              <div className="flex-1 grid gap-1">
                {title && <ToastTitle className="text-slate-900 font-bold">{title}</ToastTitle>}
                {description && <ToastDescription className="text-slate-600 font-medium">{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose className="text-slate-400 hover:text-slate-900" />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
